import {
  IExtendedRecord,
  IFlattenedHealthLogic,
  IHealthLogic,
  IHealthLogicRecord,
  IHealthLogicRecordsByDate,
  IPersonHealthLogic
} from '@/models/legacy'

function flattenHealthLogics(payload: IHealthLogic[]): IFlattenedHealthLogic[] {
  const results = payload.flatMap(logic =>
    logic.categories.map(category => ({
      name: `${logic.name} ${category.name}`,
      programId: category.id,
      healthLogicId: logic.id
    }))
  )
  return results
}

function sortHealthLogics(payload: IPersonHealthLogic[]) {
  const cancelledHealthLogics: IPersonHealthLogic[] = []
  const activeHealthLogics: IPersonHealthLogic[] = []

  payload.forEach(healthLogic => {
    if (healthLogic.currentStatus === 'Cancelado') {
      cancelledHealthLogics.push(healthLogic)
    } else {
      activeHealthLogics.push(healthLogic)
    }
  })
  return [...activeHealthLogics, ...cancelledHealthLogics]
}

function groupRecordsByDate(
  payload: IHealthLogicRecord[]
): IHealthLogicRecordsByDate[] {
  const recordsWithDiff = payload.map((record, recordIndex) => {
    const { status, categoryName, ...rest } = record
    let diff = null

    if (recordIndex < payload.length - 1) {
      diff = []
      const prevStatus = payload[recordIndex + 1].status
      const prevCategory = payload[recordIndex + 1].categoryName || ''

      if (status !== prevStatus) {
        diff.push({
          current: status,
          prev: prevStatus
        })
      }

      if (categoryName && categoryName !== prevCategory) {
        diff.push({
          current: categoryName,
          prev: prevCategory
        })
      }
    }

    return {
      ...rest,
      diff
    }
  })

  const uniqDates = payload.reduce((acc, cur) => {
    const date = cur.addedAt.slice(0, 10)
    if (!acc.includes(date)) acc.push(date)
    return acc
  }, [] as string[])

  return uniqDates.map(date => {
    const records = recordsWithDiff.reduce((acc, cur) => {
      const { addedAt, ...rest } = cur
      if (date !== addedAt.slice(0, 10)) return acc

      acc.push(rest)
      return acc
    }, [] as IExtendedRecord[])

    return {
      date,
      records
    }
  })
}

export { flattenHealthLogics, groupRecordsByDate, sortHealthLogics }
